import Entity from './entity'

export default class FriendLink extends Entity<string>{
    name: string;
    url: string;
    sortNo: number;   
}